import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import FirebaseRemote from '../../firebaseRemote';
import { isNeiWindowOpen } from '../../lib/shotTrainerNeiWindow';

@observer
class RemoteCommandBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firebaseGetReadyForShooting: null,
            firebaseStartExercise: null,
            firebaseStopExercise: null,
            firebaseEmptyGunInspectEachOther: null,
            firebaseNextStage: null,
            firebaseInspectTargets: null,
            firebaseNotReady: null,
            firebaseFinishExercise: null,
            ladingActive: false,
        };
        this.firebaseRemote = null;
        this.lastSessionId = null;
    }

    ensureRemote = (sessionId) => {
        if (sessionId && sessionId !== this.lastSessionId) {
            this.firebaseRemote = new FirebaseRemote(sessionId);
            this.lastSessionId = sessionId;
        }
        return this.firebaseRemote;
    }

    sendCommand = async (command, key) => {
        const { shotTrainerStore } = this.props.stores;
        const remote = this.ensureRemote(shotTrainerStore.firebaseRemoteSessionId);
        if (!remote) {
            return;
        }
        const result = await remote.sendCommand(command, {});
        if (command === 'finishExercise') {
            this.setState({
                firebaseGetReadyForShooting: null,
                firebaseStartExercise: null,
                firebaseStopExercise: null,
                firebaseEmptyGunInspectEachOther: null,
                firebaseNextStage: null,
                firebaseInspectTargets: null,
                firebaseNotReady: null,
                firebaseFinishExercise: null,
                ladingActive: false,
            });
            return;
        }
        // Pure remotes have no receiver feedback, so approximate the Nei window:
        // open from "Lading", kept open across "Nei er sagt" (the ready sequence
        // restarts), closed by any other command. See lib/shotTrainerNeiWindow.js.
        const ladingActive = command === 'startExercise'
            ? true
            : (command === 'notReady' ? this.state.ladingActive : false);
        this.setState({ [key]: result, ladingActive });
    }

    firebaseGetReadyForShooting = () => this.sendCommand('getReadyForShooting', 'firebaseGetReadyForShooting');
    firebaseStartExercise = () => this.sendCommand('startExercise', 'firebaseStartExercise');
    firebaseStopExercise = () => this.sendCommand('stopExercise', 'firebaseStopExercise');
    firebaseEmptyGunInspectEachOther = () => this.sendCommand('emptyGunInspectEachOther', 'firebaseEmptyGunInspectEachOther');
    firebaseNextStage = () => this.sendCommand('nextStage', 'firebaseNextStage');
    firebaseInspectTargets = () => this.sendCommand('inspectTargets', 'firebaseInspectTargets');
    firebaseNotReady = () => this.sendCommand('notReady', 'firebaseNotReady');
    firebaseFinishExercise = () => this.sendCommand('finishExercise', 'firebaseFinishExercise');

    render() {
        const {
            firebaseGetReadyForShooting,
            firebaseStartExercise,
            firebaseStopExercise,
            firebaseEmptyGunInspectEachOther,
            firebaseNextStage,
            firebaseInspectTargets,
            firebaseNotReady,
            firebaseFinishExercise,
            ladingActive,
        } = this.state;
        const { shotTrainerStore } = this.props.stores;
        const { firebaseRemoteSessionId, shootingInProgress, loadingTime, readyTime, fireTime } = shotTrainerStore;
        const { fixed = false } = this.props;

        if (!firebaseRemoteSessionId) {
            return null;
        }

        const neiWindowOpen = isNeiWindowOpen({
            shootingInProgress, loadingTime, readyTime, fireTime, ladingActive,
        });

        const positionStyle = fixed
            ? `
                position: fixed;
                bottom: 0px;
                left: 0px;
                right: 0px;
                z-index: 1040;
                box-shadow: 0px -2px 7px rgba(0, 0, 0, 0.2);
            `
            : `
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translateX(-50%);
                width: 100%;
                z-index: 1000000;
                box-shadow: 0px -2px 7px rgba(0, 0, 0, 0.2);
            `;

        const btn = (variant, active, extra = '') => (
            `btn btn-lg btn-${active ? 'outline-' : ''}${variant} rounded-pill text-nowrap `
            + `d-flex align-items-center justify-content-center ${extra}`
        );

        return (
            <div
                class='shottrainer-remote-bar bg-light px-2 py-2 border-top border-danger'
                style={`${positionStyle}font-size: 0.9rem; line-height: 1.0rem; cursor: pointer;`}
            >
                <style>{`
                    .shottrainer-remote-bar .remote-grid {
                        display: grid;
                        grid-template-columns: repeat(6, 1fr);
                        gap: 0.4rem;
                        width: 100%;
                        max-width: 720px;
                        margin: 0 auto;
                    }
                    .shottrainer-remote-bar .remote-grid .btn {
                        min-height: 56px;
                    }
                    .shottrainer-remote-bar .rg-2 { grid-column: span 2; }
                    .shottrainer-remote-bar .rg-3 { grid-column: span 3; }
                    .shottrainer-remote-bar .rg-6 { grid-column: span 6; }
                    .shottrainer-remote-bar .remote-grid .btn.remote-nei {
                        min-height: 120px;
                        font-size: 2.2rem;
                    }
                    @media (max-width: 575.98px) {
                        .shottrainer-remote-bar .remote-grid .btn {
                            min-height: 72px;
                            font-size: 1.4rem;
                            padding: 0.5rem 0.4rem;
                        }
                        .shottrainer-remote-bar .remote-grid .btn.remote-nei {
                            min-height: 200px;
                            font-size: 2.2rem;
                        }
                        .shottrainer-remote-bar .remote-grid .btn i {
                            margin-right: 0.4rem !important;
                        }
                    }
                `}</style>
                <div class='remote-grid'>
                    {neiWindowOpen && (
                        <button
                            type='button'
                            class={btn('warning', firebaseNotReady, 'rg-6 remote-nei')}
                            onClick={this.firebaseNotReady}
                        >
                            <i class='fa-duotone fa-hourglass-half me-3' />
                            <span class='d-none d-sm-inline'><Text id='shottrainer.notReady'>Not ready</Text></span>
                            <span class='d-inline d-sm-none'><Text id='shottrainer.notReady-short'>Wait</Text></span>
                        </button>
                    )}
                    <button
                        type='button'
                        class={btn('primary', firebaseGetReadyForShooting, 'rg-2')}
                        onClick={this.firebaseGetReadyForShooting}
                    >
                        <i class='fa-duotone fa-gun me-3' />
                        1. <span class='d-none d-sm-inline'><Text id='shottrainer.getReadyForShooting'>Get ready for shooting</Text></span>
                        <span class='d-inline d-sm-none'><Text id='shottrainer.getReadyForShooting-short'>Load</Text></span>
                    </button>
                    <button
                        type='button'
                        class={btn('primary', firebaseStartExercise, 'rg-2')}
                        onClick={this.firebaseStartExercise}
                    >
                        <i class='fa-duotone fa-play me-3' />
                        2. <Text id='shottrainer.start'>Start</Text>
                    </button>
                    <button
                        type='button'
                        class={btn('primary', firebaseEmptyGunInspectEachOther, 'rg-2')}
                        onClick={this.firebaseEmptyGunInspectEachOther}
                    >
                        <i class='fa-duotone fa-hand me-3' />
                        3. <span class='d-none d-sm-inline'><Text id='shottrainer.empty-gun'>Empty gun</Text></span>
                        <span class='d-inline d-sm-none'><Text id='shottrainer.empty-gun-short'>Empty</Text></span>
                    </button>
                    <button
                        type='button'
                        class={btn('primary', firebaseInspectTargets, 'rg-3')}
                        onClick={this.firebaseInspectTargets}
                    >
                        <i class='fa-duotone fa-bullseye-arrow me-3' />
                        4. <span class='d-none d-sm-inline'><Text id='shottrainer.inspect-targets'>Inspect targets</Text></span>
                        <span class='d-inline d-sm-none'><Text id='shottrainer.inspect-targets-short'>Targets</Text></span>
                    </button>
                    <button
                        type='button'
                        class={btn('primary', firebaseNextStage, 'rg-3')}
                        onClick={this.firebaseNextStage}
                    >
                        <i class='fa-duotone fa-forward me-3' />
                        5. <span class='d-none d-sm-inline'><Text id='shottrainer.secure-next-stage'>Next stage</Text></span>
                        <span class='d-inline d-sm-none'><Text id='shottrainer.secure-next-stage-short'>Next</Text></span>
                    </button>
                    <button
                        type='button'
                        class={btn('success', firebaseFinishExercise, 'rg-3')}
                        onClick={this.firebaseFinishExercise}
                    >
                        <i class='fa-duotone fa-refresh me-3' />
                        6. <Text id='shottrainer.finish'>Finish</Text>
                    </button>
                    <button
                        disabled={!firebaseStartExercise}
                        type='button'
                        class={btn('danger', firebaseStopExercise, 'rg-3')}
                        onClick={this.firebaseStopExercise}
                    >
                        <i class='fa-duotone fa-stop me-3' />
                        <span class='d-none d-sm-inline'><Text id='shottrainer.stop'>Stop</Text></span>
                        <span class='d-inline d-sm-none'><Text id='shottrainer.stop-short'>Stop</Text></span>
                    </button>
                </div>
            </div>
        );
    }
}

export default RemoteCommandBar;
